module.exports = require("lodash");


//////////////////
// WEBPACK FOOTER
// external "lodash"
// module id = 0
// module chunks = 0